import React from 'react';
import { splitTechStack, truncateTechStack } from '../../utils/projectDisplay';

const TechStackPreview: React.FC<{ stack?: string | null }> = ({ stack }) => {
  const text = (stack || '').trim();
  if (!text) return <span className="text-gray-400">—</span>;
  const { preview, truncated } = truncateTechStack(text);
  const items = splitTechStack(text);
  return (
    <span className="relative group inline-block max-w-[12rem] align-top">
      <span className="block truncate text-gray-700 cursor-default" title={truncated ? text : undefined} tabIndex={truncated ? 0 : undefined}>
        {preview}
      </span>
      {truncated && (
        <span
          role="tooltip"
          className="pointer-events-none invisible group-hover:visible group-focus-within:visible absolute z-50 left-0 bottom-full mb-1 w-64 rounded-lg border border-gray-200 bg-white p-3 text-left text-xs text-gray-800 shadow-lg"
        >
          <p className="font-semibold text-gray-900 mb-1.5">Tech stack</p>
          {items.length > 1 ? (
            <ul className="list-disc pl-4 space-y-0.5">
              {items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          ) : (
            <p className="whitespace-pre-wrap">{text}</p>
          )}
        </span>
      )}
    </span>
  );
};

export default TechStackPreview;
